<div class="boxs3">
  <div class="col-md-12 tcenter lg-font margin-top margin-bottom">
    <strong [innerHTML]="'terms.t1' | translate"></strong>
  </div>
  <br/>
  <p [innerHTML]="'terms.t2' | translate"></p>

  <br/>
  <p [innerHTML]="'terms.t3' | translate"></p>

  <p><strong [innerHTML]="'terms.t4' | translate"></strong></p>
  <p [innerHTML]="'terms.t5' | translate"></p>

  <p><strong [innerHTML]="'terms.t6' | translate"></strong></p>
  <p [innerHTML]="'terms.t7' | translate"></p>

  <p><strong [innerHTML]="'terms.t8' | translate"></strong></p>
  <p [innerHTML]="'terms.t9' | translate"></p>

  <p><strong [innerHTML]="'terms.t10' | translate"></strong></p>
  <p [innerHTML]="'terms.t11' | translate"></p>

  <p><strong [innerHTML]="'terms.t12' | translate"></strong></p>
  <p [innerHTML]="'terms.t13' | translate"></p>

  <p><strong [innerHTML]="'terms.t14' | translate"></strong></p>
  <p [innerHTML]="'terms.t15' | translate"></p>

  <p [innerHTML]="'terms.t16' | translate"></p>
  <p [innerHTML]="'terms.t17' | translate"></p>
  <p [innerHTML]="'terms.t18' | translate"></p>

  <p><strong [innerHTML]="'terms.t19' | translate"></strong></p>
  <p [innerHTML]="'terms.t20' | translate"></p>
  <p [innerHTML]="'terms.t21' | translate"></p>
  <p [innerHTML]="'terms.t22' | translate"></p>

  <p><strong [innerHTML]="'terms.t23' | translate"></strong></p>
  <p [innerHTML]="'terms.t24' | translate"></p>
  <p [innerHTML]="'terms.t25' | translate"></p>
  <p [innerHTML]="'terms.t26' | translate"></p>

  <p><strong [innerHTML]="'terms.t27' | translate"></strong></p>
  <p [innerHTML]="'terms.t28' | translate"></p>
  <p [innerHTML]="'terms.t29' | translate"></p>
  <p [innerHTML]="'terms.t30' | translate"></p>

  <p><strong [innerHTML]="'terms.t31' | translate"></strong></p>
  <p [innerHTML]="'terms.t32' | translate"></p>
  <p [innerHTML]="'terms.t33' | translate"></p>

  <p><strong [innerHTML]="'terms.t34' | translate"></strong></p>
  <p [innerHTML]="'terms.t35' | translate"></p>
  <p [innerHTML]="'terms.t36' | translate"></p>

  <p><strong [innerHTML]="'terms.t37' | translate"></strong></p>
  <p [innerHTML]="'terms.t38' | translate"></p>

  <p><strong [innerHTML]="'terms.t39' | translate"></strong></p>
  <p [innerHTML]="'terms.t40' | translate"></p>

  <p><strong [innerHTML]="'terms.t41' | translate"></strong></p>
  <p [innerHTML]="'terms.t42' | translate"></p>

  <p><strong [innerHTML]="'terms.t43' | translate"></strong></p>
  <p [innerHTML]="'terms.t44' | translate"></p>
  <p [innerHTML]="'terms.t45' | translate"></p>

  <p><strong [innerHTML]="'terms.t46' | translate"></strong></p>
  <p [innerHTML]="'terms.t47' | translate"></p>

  <p><strong [innerHTML]="'terms.t48' | translate"></strong></p>
  <p [innerHTML]="'terms.t49' | translate"></p>

  <p><strong [innerHTML]="'terms.t50' | translate"></strong></p>
  <p [innerHTML]="'terms.t51' | translate"></p>
  <p [innerHTML]="'terms.t52' | translate"></p>
  <p [innerHTML]="'terms.t53' | translate"></p>
  <p [innerHTML]="'terms.t54' | translate"></p>
  <p [innerHTML]="'terms.t55' | translate"></p>

  <p><strong [innerHTML]="'terms.t56' | translate"></strong></p>
  <p [innerHTML]="'terms.t57' | translate"></p>
  <p [innerHTML]="'terms.t58' | translate"></p>
  <p [innerHTML]="'terms.t59' | translate"></p>
  <p [innerHTML]="'terms.t60' | translate"></p>

  <div class="margin-top">
    <button type="button" class="btn btn-success" (click)="confirmUserAgreement()">{{'g.accept' | translate}}</button>
    <button type="button" class="btn btn-default" (click)="onLogout()">{{'g.decline' | translate}}</button>
  </div>
</div>